import { createColDef } from '@fortem-monorepo/react-ag'
import { Audit } from '@fortem-monorepo/web-sdk'

import { AuditCellRenderer } from '@/ag-grid/columns/audit/renderer'

export const audit = createColDef<Audit.WithApprovalInfo>({
  width: 100,
  field: 'status',
  cellRenderer: AuditCellRenderer,
})
